import { useState } from "react";
import { motion } from "framer-motion";

// Cinematic premium button: soft pop + elegant particle burst on click.
// Navigation still proceeds instantly (burst overlays, never blocks).
export default function CinematicButton({ href, onClick, className = "", children, testid, external }) {
    const [burst, setBurst] = useState(false);

    const trigger = () => {
        setBurst(true);
        setTimeout(() => setBurst(false), 700);
        if (onClick) onClick();
    };

    const shared = {
        className: `relative cinematic-btn ${className} ${burst ? "cinematic-active" : ""}`,
        "data-testid": testid,
        whileTap: { scale: 0.94 },
        whileHover: { scale: 1.03 },
        transition: { type: "spring", stiffness: 420, damping: 20 },
    };

    return (
        <span className="relative inline-block">
            {href ? (
                <motion.a
                    {...shared}
                    href={href}
                    onClick={trigger}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noopener noreferrer" : undefined}
                >
                    {children}
                </motion.a>
            ) : (
                <motion.button {...shared} type="button" onClick={trigger}>
                    {children}
                </motion.button>
            )}

            {/* particle burst overlay */}
            <span className={`cinematic-burst ${burst ? "go" : ""}`} aria-hidden="true">
                <span className="burst-ring" />
                {Array.from({ length: 8 }).map((_, i) => (
                    <i key={i} style={{ "--a": `${i * 45}deg` }} />
                ))}
            </span>
        </span>
    );
}
